import './ui.css';

interface SkeletonProps {
  /** Any CSS length; defaults to filling the container. */
  width?: string;
  height?: string;
  className?: string;
}

/**
 * Placeholder block for a first load.
 *
 * Purely decorative: the container that swaps it for real content carries
 * `aria-busy`, so assistive technology hears one "busy" instead of a wall of
 * empty boxes.
 */
export function Skeleton({ width = '100%', height = '12px', className }: SkeletonProps) {
  return (
    <span
      className={className ? `ui-skeleton ${className}` : 'ui-skeleton'}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
}
